import './App.css';
import Navbar from './Pages/Navbar';
import Footer from './Pages/Footer';
import Routing from './Pages/Routing';

import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router>
      {/* Commented out Navbar and Footer to show only the Doors page */}
      <Navbar />
      
     
      <Routing />
      
      <Footer />
    </Router>
  );
}

export default App;